import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import SelectPlanting from '@/components/SelectPlanting/SelectPlanting.vue';
import Thumbnail from '@/components/Thumbnail/Thumbnail.vue';
import SelectFromPlantings from '@/components/Record/SelectFromPlantings/SelectFromPlantings.vue'
import SelectFromAgriFields from '@/components/Record/SelectFromAgriFields/SelectFromAgriFields.vue'
import SelectTime from '@/components/Record/WorkRecord/SelectTime/SelectTime.vue'
import SelectInterval from '@/components/Record/WorkRecord/SelectInterval/SelectInterval.vue'
import WorkItemSelectModal from '@/assets/common/Modal/ItemSelectModal/WorkItemModal/WorkItemSelectModal.vue'
import MachineSelectModal from '@/assets/common/Modal/ItemSelectModal/MachineSelectModal/MachineSelectModal.vue'
import WorkerSelectModal from '@/assets/common/Modal/ItemSelectModal/WorkerSelectModal/WorkerSelectModal.vue'
import RecordInfo from '@/components/Record/RecordInfo/RecordInfo.vue'
import moment from 'moment';
import {
    File,
    WorkRecordGet,
    Worker,
    Machine,
    RecordInfoModel,
    SelectAgriFieldAndPlanting,
    WorkTimeState,
    Item, ChemicalRecord, FertilizerRecord, ExpendableMaterialRecord, DepreciationMaterialRecord
} from '@/types/Component';
import { toCamel } from 'snake-camel';
import SelectChemicals from '@/components/Record/WorkRecord/SelectChemicals/SelectChemicals.vue';
import SelectFertilizers from '@/components/Record/WorkRecord/SelectFertilizers/SelectFertilizers.vue';
import SelectDepreciationMaterials from '@/components/Record/WorkRecord/SelectDeprecationMaterials/SelectDeprecationMaterials.vue'
import SelectExpendableMaterials from '@/components/Record/WorkRecord/SelectExpendableMaterials/SelectExpendableMaterials.vue'
import store from '@/assets/common/store/store';


type WorkRecordPost = {
    kind: "SCHEDULE" | "ACTUAL", // SCHEDULE or ACTUAL
    work_date: string, // 作業日
    work_item_id: string,
    planting_id: string | null, // 作付ID
    agri_field_id: string,
    workers: WorkerPost[],
    deletedWorkers: string[], 
    machines: MachinePost[],
    chemicals: ChemicalPost[],
    fertilizers: FertilizerPost[],
    depreciation_materials: DepreciationMaterialPost[],
    expendable_materials: ExpendableMaterialPost[],
    memo: string, // メモ
}

type WorkerPost = {
    worker_id: string,
    start_worktime: string | null, // 開始時間（時間で入力の場合null）
    plan_start_worktime: string | null, // 開始時間（時間で入力の場合null）
    actual_start_worktime: string | null, // 開始時間（時間で入力の場合null）
    end_worktime: string | null, // 終了時間（時間で入力の場合null）
    plan_end_worktime: string | null, // 終了時間（時間で入力の場合null）
    actual_end_worktime: string | null, // 終了時間（時間で入力の場合null）
    rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    plan_rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    actual_rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    work_time: number, // 作業時間
    plan_work_time: number, // 作業時間
    actual_work_time: number, // 作業時間
    memo: string, // メモ
    kind: "SCHEDULE" | "ACTUAL";
}

type MachinePost = {
    machine_id: string,
    start_worktime: string | null, // 開始時間（時間で入力の場合null）
    end_worktime: string | null, // 終了時間（時間で入力の場合null）
    rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    work_time: number, // 作業時間
    memo: string, // メモ
}

type ChemicalPost = {
    warehouse_id: string, // 倉庫ID
    chemical_id: string, // 農薬ID
    usage: number, // 使用量
    memo: string // メモ
}

type FertilizerPost = {
    warehouse_id: string, // 倉庫ID
    fertilizer_id: string, // 肥料ID
    usage: number, // 使用量
    memo: string // メモ
}

type DepreciationMaterialPost = {
    warehouse_id: string,
    item_id: string,
    start_worktime: string,
    end_worktime: string,
    rest_time: number,
    work_time: number,
    memo: string
}

type ExpendableMaterialPost = {
    warehouse_id: string,
    material_id: string,
    usage: number,
    memo: string
}

const initialWorkRecord: WorkRecordGet = {
    kind: "SCHEDULE",
    workDate: moment(new Date()).format('YYYY-MM-DD'),
    workItem: {
        id: "",
        name: "",
        isHidden: false,
    },
    workUnit: {
        id:"",
        name:"",
    },
    planting: {
        id: "",
        name: "",
    },
    cropFamicId: null,
    agriField: {
        id: "",
        name: "",
        plantedArea: 0.0,
    },
    workers: [],
    machines: [],
    chemicals: [],
    fertilizers: [],
    depreciationMaterials: [],
    expendableMaterials: [],
    chemicalStockTranscation:[],
    fertilizerStockTranscation:[],
    expendableStockTranscation:[],
    pictureFileIdDetails:[],
    imageId: [""],
    memo: "",
    createdUser: {
        id: "",
        name: "",
        imageId: "",
    },
    created: new Date(),
    updatedUser: {
        id: "",
        name: "",
        imageId: ""
    },
    updated: new Date(),
    isDeletable: true
}

@Component({
    components: {
        SelectPlanting,
        Thumbnail,
        SelectFromPlantings,
        SelectFromAgriFields,
        SelectTime,
        SelectInterval,
        WorkItemSelectModal,
        MachineSelectModal,
        WorkerSelectModal,
        RecordInfo,
        SelectChemicals,
        SelectFertilizers,
        SelectDepreciationMaterials,
        SelectExpendableMaterials,
    }
})
export default class WorkRecord extends Vue {
    @Prop()
    private id: string | undefined;

    @Prop()
    private recordDate?: string

    private returnTo: string | (string | null)[] = ''

    private images: File[] = []
    private deletedImages: File[] = []

    private baseUrl = '/work_records'
    private mode = ''

    private workRecord = initialWorkRecord;
    private workerInputType: 'TIME_POINT' | 'TIME_INTERVAL' = 'TIME_POINT'
    private machineInputType: 'TIME_POINT' | 'TIME_INTERVAL' = 'TIME_POINT'
    private materialInputType: 'TIME_POINT' | 'TIME_INTERVAL' = 'TIME_POINT'

    private showSelectFromPlantings = false;
    private showSelectFromAgriFields = false;
    private showSelectTime = false;
    private showSelectInterval = false
    private selectTimeIndex: number | 'all' | undefined;
    private workerOrMachine: 'WORKER' | 'MACHINE' = 'WORKER'

    private targetSelectTime: WorkTimeState | null = null

    private showWorkItemSelect = false
    private showMachineSelect = false
    private showWorkerSelect = false

    private showSelectChemicals = false
    private showSelectFertilizers = false
    private showSelectDepreciationMaterials = false
    private showSelectExpendableMaterials = false

    // 時刻選択
    private materialRestHour = 0
    private materialRestMinute = 0
    private minutes = [
        {value: 0, display: '0分'},
        {value: 5, display: '5分'},
        {value: 10, display: '10分'},
        {value: 15, display: '15分'},
        {value: 20, display: '20分'},
        {value: 25, display: '25分'},
        {value: 30, display: '30分'},
        {value: 35, display: '35分'},
        {value: 40, display: '40分'},
        {value: 45, display: '45分'},
        {value: 50, display: '50分'},
        {value: 55, display: '55分'},
    ]

    private hours = [
        {value: 0, display: '0時間'},
        {value: 60, display: '1時間'},
        {value: 120, display: '2時間'},
        {value: 180, display: '3時間'},
        {value: 240, display: '4時間'},
        {value: 300, display: '5時間'},
        {value: 360, display: '6時間'},
        {value: 420, display: '7時間'},
        {value: 480, display: '8時間'},
        {value: 540, display: '9時間'},
        {value: 600, display: '10時間'},
        {value: 660, display: '11時間'},
        {value: 720, display: '12時間'},
        {value: 780, display: '13時間'},
        {value: 840, display: '14時間'},
        {value: 900, display: '15時間'},
        {value: 960, display: '16時間'},
        {value: 1020, display: '17時間'},
        {value: 1080, display: '18時間'},
        {value: 1140, display: '19時間'},
        {value: 1200, display: '20時間'},
        {value: 1260, display: '21時間'},
        {value: 1320, display: '22時間'},
        {value: 1380, display: '23時間'},
    ]

    deleteWorkersIdArr = [] as string []

    getHour(restTime: number): number {
        return Math.floor(restTime / 60) * 60
    }
    getMinute(restTime: number): number {
        return restTime % 60
    }

    // 作成者/更新者
    private recordInfo: RecordInfoModel | null = null

    created(): void {
        this.returnTo = this.$route.query.return_to
    }

    // idが空じゃない場合は単体GETする
    async mounted(): Promise<void> {
        this.init()
        if (this.recordDate !== null && this.recordDate !== undefined) {
            this.workRecord.workDate = this.recordDate
        } else {
            this.workRecord.workDate = moment(new Date()).format('YYYY-MM-DD')
        }
        if (this.id !== undefined && this.id !== '') {
            const res = toCamel(await this.$apiClient.doRequest('get', '/work_records/' + this.id)) as WorkRecordGet

            if(res.planting == null) {
                res.planting = {
                    id: null,
                    name: '作付を指定しない',
                    crop: {
                        id: '',
                        name: '',
                        phonetic: ''
                    }
                }
            }
                   const workerRecord : Worker[] = res.workers.map((item: any) => {
                    return {
                        worker: {
                            id: item.worker.id, 
                            name: item.worker.name 
                        },
                        startWorktime: item.kind === "SCHEDULE"? item.planStartWorktime:item.actualStartWorktime ,
                        planStartWorktime: item.planStartWorktime,
                        actualStartWorktime: item.actualStartWorktime,
                        endWorktime:  item.kind === "SCHEDULE"? item.planEndWorktime : item.actualEndWorktime,
                        planEndWorktime: item.planEndWorktime, 
                        actualEndWorktime: item.actualEndWorktime,
                        restTime: item.kind === "SCHEDULE" ? item.planRestTime : item.actualRestTime,
                        planRestTime: item.planRestTime, 
                        actualRestTime: item.actualRestTime,
                        workTime: item.kind === "SCHEDULE" ? item.planWorkTime : item.actualWorkTime ,
                        planWorkTime: item.planWorkTime, 
                        actualWorkTime: item.actualWorkTime,
                        quantity:item.quantity,
                        memo: item.memo,
                        kind: item.kind,
                        workerUpdatedTime : item.workerUpdatedTime
                    };
                });
                    const workRecordData = { ...res };
                    workRecordData.workers = workerRecord;
                    this.workRecord = workRecordData;
            this.mode = 'edit'
            let workerInputTypeIsTimePoint
            if(this.workRecord.workers.length) {
                workerInputTypeIsTimePoint = this.workRecord.workers
                .map(w => 
                    this.workRecord.kind === "SCHEDULE" ?  w.planStartWorktime !== null && w.planEndWorktime !== null && w.planRestTime !== null :
                    w.actualStartWorktime !== null && w.actualEndWorktime !==null && w.actualRestTime!==null
                    ).reduce((res, b) => 
                    res && b
                    )
                }
            this.workerInputType = workerInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'
            let machineInputTypeIsTimePoint
            if(this.workRecord.machines.length) {
                machineInputTypeIsTimePoint = this.workRecord.machines
                    .map(m => m.startWorktime !== null && m.endWorktime !== null && m.restTime !== null)
                    .reduce((res, b) => res && b)
            }
            this.machineInputType = machineInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'

            this.workRecord.imageId.forEach(imi => {
                this.$apiClient.doRequest('get', `${this.baseUrl}/${this.id}/images/${imi}/`).then(res => {
                    const file = toCamel(res) as File
                    this.images.push(file)
                })
            })

            this.recordInfo = {
                createdUser: this.workRecord.createdUser,
                created: this.workRecord.created.toString(),
                updatedUser: this.workRecord.updatedUser,
                updated: this.workRecord.updated.toString()
            }
        }
    }

    private init() {
        this.workRecord = {
            kind: "SCHEDULE",
            workDate: moment(new Date()).format('YYYY-MM-DD'),
            workItem: {
                id: "",
                name: "",
                isHidden: false,
            },
            workUnit: {
                id:"",
                name:"",
            },
            planting: {
                id: "",
                name: "",
            },
            cropFamicId: null,
            agriField: {
                id: "",
                name: "",
                plantedArea: 0.0,
            },
            workers: [],
            machines: [],
            chemicals: [],
            fertilizers: [],
            depreciationMaterials: [],
            expendableMaterials: [],
            chemicalStockTranscation:[],
            fertilizerStockTranscation:[],
            expendableStockTranscation:[],
            pictureFileIdDetails:[],
            imageId: [""],
            memo: "",
            createdUser: {
                id: "",
                name: "",
                imageId: "",
            },
            created: new Date(),
            updatedUser: {
                id: "",
                name: "",
                imageId: ""
            },
            updated: new Date(),
            isDeletable: true
        }
        this.images = []
        this.workerInputType = 'TIME_POINT'
        this.machineInputType = 'TIME_POINT'
    }

    private updateDate() {
        const selectTimeRef: any = this.$refs.selectTime
        selectTimeRef.update()
        this.inputChanged()
    }

    // 分を時間表記に変更する
    private minuteToHour(minute: number) {
        return minute ? Math.floor(minute / 60) + '時間' + minute % 60 + '分' : '0時間0分';
    }

    // モーダル操作系
    private openSelectFrom(str: string) {
        if (str === 'PLANTINGS') {
            this.showSelectFromPlantings = true
        } else {
            this.showSelectFromAgriFields = true
        }
        this.inputChanged()
    }

    private openWorkerSelectTime(idx: number | 'all') {
        const isTime = this.workerInputType === 'TIME_POINT'
        if (isTime) {
            this.showSelectTime = true
        } else {
            this.showSelectInterval = true
        }
        this.selectTimeIndex = idx
        if(typeof idx === 'number') {
            const worker = this.workRecord.workers[idx]
            // 既に作業時間（時刻の時は＋開始・終了時間）が入っているときはそれを初期値とする
            if(worker.workTime > 0 && (!isTime || (worker.startWorktime && worker.endWorktime))) {
                this.targetSelectTime = {
                    startWorktime: worker.startWorktime,
                    endWorktime: worker.endWorktime,
                    restTime: worker.restTime,
                    workTime: worker.workTime,
                }
            }
        }
        this.workerOrMachine = 'WORKER'
        this.inputChanged()
    }

    private openMachineSelectTime(idx: number | 'all') {
        if (this.machineInputType === 'TIME_POINT') {
            this.showSelectTime = true
        } else {
            this.showSelectInterval = true
        }
        this.selectTimeIndex = idx
        if(typeof idx === 'number') {
            const machine = this.workRecord.machines[idx]
            // 既に作業時間が入っているときはそれを初期値とする
            if(machine.workTime > 0) {
                this.targetSelectTime = {
                    startWorktime: machine.startWorktime,
                    endWorktime: machine.endWorktime,
                    restTime: machine.restTime,
                    workTime: machine.workTime
                } as WorkTimeState
            }
        }
        this.workerOrMachine = 'MACHINE'
        this.inputChanged()
    }

    private initializeMachines(machines: Machine[]) {
        return machines.map(m => ({
            ...m.machine,
            isHidden: false,
        }))
    }

    private initializeWokers(workers: Worker[]) {
        return workers.map(w => ({
            ...w.worker,
            isHidden: false,
        }))
    }

    private commitWorkItem(value: Item) {
        this.workRecord.workItem = value
    }

    private updateWorkItem(value: Item) {
        if (value && this.workRecord.workItem.id) {
            this.workRecord.workItem = value
        }
    }

    private commitWorkers(value: { id: string, name: string }[]) {
        const existingWorker = this.workRecord.workers.filter(w => value.find(v => v.id === w.worker.id) !== undefined)
        const newWorker: Worker[] = value
            .filter(v => this.workRecord.workers.find(w => w.worker.id === v.id) === undefined)
            .map(v => ({
                worker: v,
                startWorktime: null,
                planStartWorktime: null,
                actualStartWorktime: null,
                endWorktime: null,
                planEndWorktime: null,
                actualEndWorktime: null,
                restTime: null,
                planRestTime: null,
                actualRestTime: null,
                workTime: 0,
                planWorkTime: 0,
                actualWorkTime: 0,
                quantity:0,
                memo: "",
                kind :"SCHEDULE",
                workerUpdatedTime : ""
            }))
        this.workRecord.workers = [...existingWorker, ...newWorker]
    }

    private commitMachines(value: { id: string, name: string }[]) {
        const newMachines: Machine[] = value.map(v => {
            const existingMachine = this.workRecord.machines.find(m => m.machine.id === v.id)
            return {
                machine: v,
                startWorktime: existingMachine ? existingMachine.startWorktime : null,
                endWorktime: existingMachine ? existingMachine.endWorktime : null,
                restTime: existingMachine ? existingMachine.restTime : null,
                workTime: existingMachine ? existingMachine.workTime : 0,
                memo: existingMachine ? existingMachine.memo : "",
                machineUpdatedTime : existingMachine ? existingMachine.machineUpdatedTime : ""
            }
        })
        this.workRecord.machines = [...newMachines]
    }

    private updateMachine(value: Item) {
        this.workRecord.machines.forEach(item => {
            if (value && item.machine.id === value.id) {
                item.machine = value
            }
        })
    }

    private commitTime(value: WorkTimeState) {
        if (this.workerOrMachine === 'WORKER') {
            if (typeof this.selectTimeIndex === 'number') {
                const worker = this.workRecord.workers[this.selectTimeIndex]
                this.workRecord.workers[this.selectTimeIndex] = { ...worker, ...value }
            } else if (this.selectTimeIndex === 'all') {
                this.workRecord.workers = this.workRecord.workers.map(w => ({ ...w, ...value }))
            }
        } else if (this.workerOrMachine === 'MACHINE') {
            if (typeof this.selectTimeIndex === 'number') {
                const machine = this.workRecord.machines[this.selectTimeIndex]
                this.workRecord.machines[this.selectTimeIndex] = { ...machine, ...value }
            } else if (this.selectTimeIndex === 'all') {
                this.workRecord.machines = this.workRecord.machines.map(m => ({ ...m, ...value }))
            }
        }
        this.targetSelectTime = value
    }

    private commitPlantingAndField(value: SelectAgriFieldAndPlanting) {
        const agriField = { id: value.agriField.id, name: value.agriField.name, plantedArea: value.agriField.plantedArea }
        this.workRecord = { ...this.workRecord, planting: value.planting, agriField: agriField }
    }

    private displayTime(time: string | null) {
        return time ? time.slice(0, 5) : ''
    }

    private changeTime(item: DepreciationMaterialRecord, index: number) {
        const start = moment(item.startWorktime, 'HH:mm')
        const end = moment(item.endWorktime, 'HH:mm')
        if(start.isValid() && end.isValid()) {
            const workTime = end.diff(start, 'minutes')
            const newDepreciationMaterials = this.workRecord.depreciationMaterials
            newDepreciationMaterials[index] = {
                ...newDepreciationMaterials[index],
                workTime: workTime
            }
            this.$set(this.workRecord, "depreciationMaterials", newDepreciationMaterials)
        }
        this.inputChanged()
    }
    get materialDisplayTime() {
        return (item: DepreciationMaterialRecord) => {
            const start = moment(item.startWorktime, 'HH:mm')
            const end = moment(item.endWorktime, 'HH:mm')
            if (start.isValid() && end.isValid()) {
                const workTime = end.diff(start, 'minutes')
                return Math.floor(workTime / 60) + '時間' + workTime % 60 + '分';
            }
            else {
                return '0時間0分'
            }
        }
    }

    // ファイル系
    private onFileChange(e: any) {
        const files = e.target.files || e.dataTransfer.files;

        if (this.$apiClient.isSizeOver(files)) {
            return
        }

        for (const file of files) {
            if (this.$apiClient.isImageFile(file.name)) {
                this.$apiClient.getBase64(file).then((image: any) => {
                    const item = {
                        file: image.file,
                        url: image.base64
                    } as File
                    this.images.push(item)
                }).catch(() => {
                    window.alert('画像ファイルが読み込めませんでした')
                })
            } else {
                window.alert('画像ファイルを選択してください')
            }
        }

        e.target.value = ''
        this.inputChanged()
    }

    private deleteImage(image: File, index: number) {
        this.images.splice(index, 1)
        if (image.id) {
            this.deletedImages.push(image)
        }
        this.inputChanged()
    }

    private delPlantingAndField() {
        this.workRecord = { ...this.workRecord, planting: { id: '', name: '' }, agriField: { id: '', name: '', plantedArea: 0 } }
    }

    private validation(): boolean {
        const errmsg: string[] = []

        if (!this.workRecord.workDate) {
            errmsg.push('作業日を選択してください。')
        }

        if (this.workRecord.workItem.id === "") {
            errmsg.push('作業項目を選択してください。')
        }
        if (this.workRecord.planting.id === "" || this.workRecord.agriField.id === "") {
            errmsg.push('作付・圃場を選択してください。')
        }
        if(this.workRecord.workers.length > 0) {
            this.workRecord.workers.forEach(worker => {
                if(worker.memo && worker.memo.length > 21844) {
                    errmsg.push(`メモは21844文字以内で入力してください（現在は${worker.memo.length}文字, 作業者：${worker.worker.name}）`)
                }
            })
        }
        if(this.workRecord.machines.length > 0) {
            this.workRecord.machines.forEach(machine => {
                if(machine.memo && machine.memo.length > 21844) {
                    errmsg.push(`メモは21844文字以内で入力してください（現在は${machine.memo.length}文字, 機械：${machine.machine.name}）`)
                }
            })
        }
        if(this.workRecord.chemicals && this.workRecord.chemicals.length > 0) {
            this.workRecord.chemicals.forEach(chemical => {
                if(!chemical.usage) {
                    errmsg.push(`使用量を入力してください（農薬：${chemical.chemicalDisplayName}）`)
                } else {
                    const usageStr = chemical.usage.toString().split('.')
                    if(!(chemical.usage > 0) || usageStr[0].length > 7 || (usageStr[1] && usageStr[1].length > 2)) {
                        errmsg.push(`使用量は0より大きい整数部7桁小数部2桁までの数値を入力してください（農薬：${chemical.chemicalDisplayName}）`)
                    }
                }
                if(chemical.memo && chemical.memo.length > 21844) {
                    errmsg.push(`メモは21844文字以内で入力してください（現在は${chemical.memo.length}文字, 農薬：${chemical.chemicalDisplayName}）`)
                }
            })
        }
        if(this.workRecord.fertilizers && this.workRecord.fertilizers.length > 0) {
            this.workRecord.fertilizers.forEach(fertilizer => {
                if(!fertilizer.usage) {
                    errmsg.push(`使用量を入力してください（肥料：${fertilizer.fertilizerName}）`)
                } else {
                    const usageStr = fertilizer.usage.toString().split('.')
                    if(!(fertilizer.usage > 0) || usageStr[0].length > 7 || (usageStr[1] && usageStr[1].length > 2)) {
                        errmsg.push(`使用量は0より大きい整数部7桁小数部2桁までの数値を入力してください（肥料：${fertilizer.fertilizerName}）`)
                    }
                }
                if(fertilizer.memo && fertilizer.memo.length > 21844) {
                    errmsg.push(`メモは21844文字以内で入力してください（現在は${fertilizer.memo.length}文字, 肥料：${fertilizer.fertilizerName}）`)
                }
            })
        }
        if(this.workRecord.depreciationMaterials.length > 0) {
            this.workRecord.depreciationMaterials.forEach(material => {
                if(material.memo && material.memo.length > 21844) {
                    errmsg.push(`メモは21844文字以内で入力してください（現在は${material.memo.length}文字, 資材（減価償却）：${material.displayName}）`)
                }
            })
        }
        if(this.workRecord.expendableMaterials && this.workRecord.expendableMaterials.length > 0) {
            this.workRecord.expendableMaterials.forEach(material => {
                if(!material.usage) {
                    errmsg.push(`使用量を入力して下さい（資材（消耗品）：${material.materialName}）`)
                } else {
                    const usageStr = material.usage.toString().split('.')
                    if(!(material.usage > 0) || usageStr[0].length > 7 || (usageStr[1] && usageStr[1].length > 2)) {
                        errmsg.push(`使用量は0より大きい整数部7桁小数部2桁までの数値を入力して下さい（資材（消耗品）：${material.materialName}）`)
                    }
                }
                if(material.memo && material.memo.length > 21844) {
                    errmsg.push(`メモは21844文字以内で入力して下さい（現在は${material.memo.length}文字, 資材（消耗品）：${material.materialName}）`)
                }
            })
        }
        if(this.workRecord.memo && this.workRecord.memo.length > 21844) {
            errmsg.push(`メモは21844文字以内で入力してください（現在は${this.workRecord.memo.length}文字）`)
        }


        if (errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }
        return true
    }

    saveRecord(isNotRefresh: boolean | null): boolean {
        if (!this.validation()) {
            return false
        }
        const data: WorkRecordPost = {
            kind: this.workRecord.kind,
            work_date: this.workRecord.workDate,
            work_item_id: this.workRecord.workItem.id,
            planting_id: this.workRecord.planting.id,
            agri_field_id: this.workRecord.agriField.id,
            workers: this.workRecord.workers.map(w => ({
                worker_id: w.worker.id,
                start_worktime: w.startWorktime,
                plan_start_worktime: this.workRecord.kind === "SCHEDULE" ? w.startWorktime : w.planStartWorktime,
                actual_start_worktime: this.workRecord.kind === "ACTUAL" ? w.startWorktime : null,
                end_worktime: w.endWorktime,
                plan_end_worktime: this.workRecord.kind === "SCHEDULE" ? w.endWorktime : w.planEndWorktime,
                actual_end_worktime: this.workRecord.kind === "ACTUAL" ? w.endWorktime : null,
                rest_time: w.restTime == null ? 0 : w.restTime,
                plan_rest_time: this.workRecord.kind === "SCHEDULE" ? (w.restTime == null ? 0 : w.restTime) : (w.planRestTime == null ? 0 : w.planRestTime),
                actual_rest_time: this.workRecord.kind === "ACTUAL" ? (w.restTime== null ? 0 : w.restTime) : 0,
                work_time: w.workTime,
                plan_work_time: this.workRecord.kind === "SCHEDULE" ? (w.workTime== null ? 0 : w.workTime) : (w.planWorkTime == null ? 0: w.planWorkTime),
                actual_work_time: this.workRecord.kind === "ACTUAL" ? w.workTime : 0,
                kind: (this.workRecord.kind === "ACTUAL" && w.planStartWorktime !== null || this.workRecord.kind === "ACTUAL" && w.planStartWorktime == null ) ? "ACTUAL" : "SCHEDULE",
                memo: w.memo,
            })), 
            deletedWorkers:this.deleteWorkersIdArr,
            machines: this.workRecord.machines.map(w => ({
                machine_id: w.machine.id,
                start_worktime: w.startWorktime,
                end_worktime: w.endWorktime,
                rest_time: w.restTime == null ? 0 : w.restTime,
                work_time: w.workTime,
                memo: w.memo,
            })),
            chemicals: this.workRecord.chemicals.map(chemical => ({
                chemical_id: chemical.chemicalId,
                warehouse_id: chemical.warehouseId,
                usage: chemical.usage == null ? 0 : chemical.usage,
                memo: chemical.memo
            })),
            fertilizers: this.workRecord.fertilizers.map(fertilizer => ({
                fertilizer_id: fertilizer.fertilizerId,
                warehouse_id: fertilizer.warehouseId,
                usage: fertilizer.usage,
                memo: fertilizer.memo
            })),
            depreciation_materials: this.workRecord.depreciationMaterials.map(material => ({
                item_id: material.itemId,
                warehouse_id: material.warehouseId,
                start_worktime: material.startWorktime,
                end_worktime: material.endWorktime,
                rest_time: this.materialRestHour + this.materialRestMinute,
                work_time: material.workTime,
                memo: material.memo
            })),
            expendable_materials: this.workRecord.expendableMaterials.map(material => ({
                material_id: material.materialId,
                warehouse_id: material.warehouseId,
                usage: material.usage,
                memo: material.memo
            })),
            memo: this.workRecord.memo,
        }

        let property: {
            method: 'post' | 'put',
            url: string,
            message: string,
        } = {
            method: 'post',
            url: this.baseUrl,
            message: '保存しました。'
        }
        if (this.mode === 'edit') {
            if(!window.confirm("内容を上書きして保存します。よろしいですか。")) {
                return false
            }
            property = {
                method: 'put',
                url: `${this.baseUrl}/${this.id}`,
                message: '変更を保存しました。'
            }
        }

        this.$apiClient.doRequest(property.method, property.url, data)
            .then(res => {
                const promise: Promise<{ id: string }>[] = []
                this.images.forEach(im => {
                    if (im.file !== null && im.file !== undefined) {
                        promise.push(this.$apiClient.fileUpload(`${this.baseUrl}/${res.id}/images/`, im.file))
                    }
                })
                this.deletedImages.forEach(im => {
                    promise.push(this.$apiClient.doRequest('delete', `${this.baseUrl}/${res.id}/images/${im.id}/`))
                })
                Promise.all(promise).then(() => {
                    this.$toasted.success(property.message)

                    // 添付ファイル情報は複製対象外のため、無条件で初期化
                    this.workRecord.imageId = [""]
                    this.images = []

                    if(isNotRefresh !== true) {
                        if (this.returnTo !== undefined) {
                            this.$router.push(`/${this.$route.query.return_to}?date=${this.workRecord.workDate}`).then(() => { return })
                        } else {
                            this.workRecord = initialWorkRecord
                        }
                        this.init()
                    }
                })
            })
            .catch(() => {
                this.$toasted.error('保存に失敗しました。')
            })
        
        return true
    }

    saveAndCopyRecord() :void {
        const successRequest = this.saveRecord(true)
        if(successRequest) {
            this.mode = ''
            this.recordInfo = null
        }
    }

    deleteRecord(): void {
        const confirm = window.confirm('削除しますか？')
        if(confirm) {
            this.$apiClient.doRequest('delete', `${this.baseUrl}/${this.id}`)
                .then(() => {
                    this.$toasted.success('削除しました。')
                    this.$router.push('/calendar').then(() => { return })
                })
                .catch(() => {
                    this.$toasted.error('削除に失敗しました。')
                })
        } else {
            this.$toasted.success('削除がキャンセルされました。')
        }
    }

    deleteWorker(index: number,workerId:string): void {
        this.deleteWorkersIdArr.push(workerId);
        this.workRecord.workers.splice(index, 1)
        this.inputChanged()
    }

    deleteMachine(index: number): void {
        this.workRecord.machines.splice(index, 1)
        this.inputChanged()
    }

    private commitChemicals(value: ChemicalRecord[]) {
        const newChemicals: ChemicalRecord[] = value.map(item => {
            const existingChemicals = this.workRecord.chemicals.find(chemical => chemical.warehouseId === item.warehouseId && chemical.chemicalId === item.chemicalId)
            return {
                chemicalId: item.chemicalId,
                chemicalDisplayName: item.chemicalDisplayName,
                chemicalUnitName: item.chemicalUnitName,
                warehouseId: item.warehouseId,
                warehouseName: item.warehouseName,
                usage: existingChemicals?.usage,
                memo: existingChemicals?.memo
            }
        }) as ChemicalRecord[]
        this.workRecord.chemicals = newChemicals
    }

    private deleteChemical(index: number): void {
        this.workRecord.chemicals.splice(index, 1)
        this.inputChanged()
    }

    private commitFertilizers(value: FertilizerRecord[]) {
        const newFertilizers: FertilizerRecord[] = value.map(item => {
            const existingFertilizers = this.workRecord.fertilizers.find(fertilizer => fertilizer.warehouseId === item.warehouseId && fertilizer.fertilizerId === item.fertilizerId)
            return {
                fertilizerId: item.fertilizerId,
                fertilizerName: item.fertilizerName,
                fertilizerUnitName: item.fertilizerUnitName,
                warehouseId: item.warehouseId,
                warehouseName: item.warehouseName,
                usage: existingFertilizers?.usage,
                memo: existingFertilizers?.memo
            }
        }) as FertilizerRecord[]
        this.workRecord.fertilizers = newFertilizers
    }

    private deleteFertilizer(index: number): void {
        this.workRecord.fertilizers.splice(index, 1)
        this.inputChanged()
    }

    private commitExpendableMaterials(value: ExpendableMaterialRecord[]) {
        const newExpendableMaterials: ExpendableMaterialRecord[] = value.map(item => {
            const existingExpendableMaterials = this.workRecord.expendableMaterials.find(material => material.warehouseId === item.warehouseId && material.materialId === item.materialId)
            return {
                ...item,
                usage: existingExpendableMaterials?.usage,
                memo: existingExpendableMaterials?.memo
            }
        }) as ExpendableMaterialRecord[]
        this.workRecord.expendableMaterials = newExpendableMaterials
    }

    private deleteExpendableMaterial(index: number): void {
        this.workRecord.expendableMaterials.splice(index, 1)
        this.inputChanged()
    }

    private commitDepreciationMaterials(value: DepreciationMaterialRecord[]) {
        const newDepreciationMaterials: DepreciationMaterialRecord[] = value.map(item => {
            const existingDepreciationMaterials = this.workRecord.depreciationMaterials.find(material => material.warehouseId === item.warehouseId && material.itemId === item.itemId)
            return {
                ...item,
                memo: existingDepreciationMaterials?.memo,
                startWorktime: existingDepreciationMaterials?.startWorktime,
                endWorktime: existingDepreciationMaterials?.endWorktime,
                restTime: existingDepreciationMaterials?.restTime,
                workTime: existingDepreciationMaterials?.workTime,
            }
        }) as DepreciationMaterialRecord[]
        this.workRecord.depreciationMaterials = newDepreciationMaterials
    }

    private deleteDepreciationMaterials(index: number): void {
        this.workRecord.depreciationMaterials.splice(index, 1)
        this.inputChanged()
    }

    @Emit('inputChanged')
    private inputChanged(){
        if(store.getters.isInputChanged==false){
         this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }

    async changePlan(){
        const workerKind = this.workRecord.workers.find(item => item.kind=="ACTUAL")
        if(this.workRecord.kind === "ACTUAL" && workerKind){
            const result = window.confirm('作業者の実績時間が削除されますが、予定に変更しますか？');
            if(!result){
              this.revertRecord()
            }
            else{
            const responsePlan = this.workRecord;
                const workerRecord : Worker[] = responsePlan.workers.map((item: any) => {
                    return {
                        worker: {
                            id: item.worker.id, 
                            name: item.worker.name 
                        },
                        startWorktime: item.planStartWorktime,
                        planStartWorktime: item.planStartWorktime,
                        actualStartWorktime: item.actualStartWorktime,
                        endWorktime: item.planEndWorktime ,
                        planEndWorktime: item.planEndWorktime, 
                        actualEndWorktime: item.actualEndWorktime,
                        restTime:item.planRestTime,
                        planRestTime: item.planRestTime, 
                        actualRestTime: item.actualRestTime,
                        workTime: item.planWorkTime,
                        planWorkTime: item.planWorkTime, 
                        actualWorkTime: item.actualWorkTime,
                        quantity:item.quantity,
                        memo: item.memo,
                        kind: "SCHEDULE",
                        workerUpdatedTime : item.workerUpdatedTime
                    };
                });
                    const workRecordData = { ...responsePlan };
                    workRecordData.kind =this.workRecord.kind
                    workRecordData.workers = workerRecord;
                    this.workRecord = workRecordData;
            } 
        }  
    }

    async revertRecord(){
        const res = toCamel(await this.$apiClient.doRequest('get', '/work_records/' + this.id)) as WorkRecordGet
        if(res.planting == null) {
            res.planting = {
                id: null,
                name: '作付を指定しない',
                crop: {
                    id: '',
                    name: '',
                    phonetic: ''
                }
            }
        }
        const workerRecord : Worker[] = res.workers.map((item: any) => {
            return {
                worker: {
                    id: item.worker.id, 
                    name: item.worker.name 
                },
                startWorktime: item.actualStartWorktime ? item.actualStartWorktime : item.planStartWorktime,
                planStartWorktime: item.planStartWorktime,
                actualStartWorktime: item.actualStartWorktime,
                endWorktime: item.actualEndWorktime ? item.actualEndWorktime :item.planEndWorktime,
                planEndWorktime: item.planEndWorktime, 
                actualEndWorktime: item.actualEndWorktime,
                restTime: item.actualRestTime === 0 ? item.actualRestTime :item.planRestTime,
                planRestTime: item.planRestTime, 
                actualRestTime: item.actualRestTime,
                workTime: item.actualWorkTime ? item.actualWorkTime :item.planWorkTime,
                planWorkTime: item.planWorkTime, 
                actualWorkTime: item.actualWorkTime,
                quantity:item.quantity,
                memo: item.memo,
                kind: item.kind,
                workerUpdatedTime : item.workerUpdatedTime
            };
        });
            const workRecordData = { ...res };
            workRecordData.workers = workerRecord;
            this.workRecord = workRecordData;
        this.mode = 'edit'
        let workerInputTypeIsTimePoint
        if(this.workRecord.workers.length) {
            workerInputTypeIsTimePoint = this.workRecord.workers
                .map(w => w.startWorktime !== null && w.endWorktime !== null && w.restTime !== null)
                .reduce((res, b) => res && b)
        }
        this.workerInputType = workerInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'
        let machineInputTypeIsTimePoint
        if(this.workRecord.machines.length) {
            machineInputTypeIsTimePoint = this.workRecord.machines
                .map(m => m.startWorktime !== null && m.endWorktime !== null && m.restTime !== null)
                .reduce((res, b) => res && b)
        }
        this.machineInputType = machineInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'

        this.workRecord.imageId.forEach(imi => {
            this.$apiClient.doRequest('get', `${this.baseUrl}/${this.id}/images/${imi}/`).then(res => {
                const file = toCamel(res) as File
                this.images.push(file)
            })
        })

        this.recordInfo = {
            createdUser: this.workRecord.createdUser,
            created: this.workRecord.created.toString(),
            updatedUser: this.workRecord.updatedUser,
            updated: this.workRecord.updated.toString()
        }
    }

    async cancelRecord(): Promise<void> {
        const result = window.confirm('変更内容を破棄します。よろしいですか。')
        if (result) {
        if (this.id !== undefined && this.id !== '') {
           this.init()
           this.revertRecord()
        }
        else{
            this.init()
          }
        }
        this.$store.dispatch('doUpdateIsInputChanged', false);
    }
}
